import { useContext } from 'react'
import { KeycloakService } from '@nv/auth'
import { KeycloakAdminService } from '@nv/auth'
import { NVButton } from '@nv/basic-components'
import { LoginFlowContext } from '@nv/contexts'
import { AdminVoterAuthService } from '@nv/services'
import { VoterAuthService } from '@nv/services'
import { beforeUnload } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const LogoutButton = () => {
  const navigate = useNavigate()
  const LOGIN_CONTEXT = useContext(LoginFlowContext)
  const { t } = useTranslation()

  const handleLogout = async () => {
    window.removeEventListener('beforeunload', beforeUnload)
    try {
      if (KeycloakService.isLoggedIn()) {
        LOGIN_CONTEXT.setLoginFlow('Login')
        await VoterAuthService.logOut(navigate)
      }
      if (KeycloakAdminService.isLoggedIn()) {
        LOGIN_CONTEXT.setLoginFlow('Admin Login')
        await AdminVoterAuthService.logOut(navigate)
      }
    } catch (error) {
      //console.log(error)
    }
  }

  return (
    <NVButton
      variant={'text'}
      onClick={() => handleLogout()}
      text={t('main.logout')}
      style={{ container: { padding: 0 }, content: { color: 'var(--color-white)' } }}
    />
  )
}

export default LogoutButton
